import { Component, Inject, OnInit } from '@angular/core';
import { CoreDirectivesModule } from '../../../@core/directives/directives';
import { environment } from '../../../environments/environment';
import { IEnvironment, IEnvironmentToken } from '../../../environments/environment.interface';
import { TranslocoRootModule } from '../../transloco-root.module';
import { TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-social-logins-links',
    standalone: true,
    imports: [CoreDirectivesModule, TranslocoRootModule, CommonModule],
    templateUrl: './social-logins-links.component.html',
    styleUrl: './social-logins-links.component.scss',
    providers: [
        { provide: IEnvironmentToken, useValue: environment }
    ]
})
export class SocialLoginsLinksComponent implements OnInit {

    constructor(
        @Inject(IEnvironmentToken) private environment: IEnvironment,
        private translocoService: TranslocoService
    ) {
        this.environment = environment;
    }

    public lastLogin: string = '';

    ngOnInit(): void {
        const lastLoginMethod = localStorage.getItem('lastLoginMethod');
        if (lastLoginMethod) {
            this.lastLogin = lastLoginMethod;
        }

    }

    setLastLoginMethod(method: string) {
        localStorage.setItem('lastLoginMethod', method);
    }

    get googleUrl(): string {
        return this.buildUrl(this.environment?.socialLoginsURL?.google);
    }

    get microsoftUrl(): string {
        return this.buildUrl(this.environment?.socialLoginsURL?.microsoft);
    }

    get linkedInUrl(): string {
        return this.buildUrl(this.environment?.socialLoginsURL?.linkedin);
    }

    private buildUrl(path: string): string {
        return `${this.environment?.socialLoginsURL?.baseURL}${path}`;
    }

}